import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Morebtn from 'components_v2/mobile/Morebtn';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import s from './ListingStoriesWidget.scss';

const ListingStoriesWidget = props => {
  const { storiesData, sectionData, cardCount = 0 } = props;

  const onStoryClick = (event, item, index) => {
    event.preventDefault();
    if (sectionData && sectionData.secName) {
      sendGaThroughProps({
        data: {
          gaCategory: 'mWEB-articleshowv2',
          gaAction: 'Click',
          gaLabel: `New_Trending-Stories_In-${sectionData.secName}_${cardCount +
            index}`,
        },
      });
    } else {
      sendGaThroughProps({
        data: {
          gaCategory: 'mWEB-articleshowv2',
          gaAction: 'Click',
          gaLabel: `New_Trending-Stories_In-TOI_Story-${cardCount + index}`,
        },
      });
    }
    window.location.href = item.wu;
  };

  const getItemType = (templateName, itemLink) => {
    let itemType = 'news';
    switch (templateName) {
      case 'photostory':
        itemType = 'photostory';
        if (
          itemLink &&
          typeof itemLink === 'string' &&
          itemLink.includes('photogallery.indiatimes.com')
        ) {
          itemType = 'photogallery';
        }
        break;
      case 'video':
        itemType = 'video';
        break;
      case 'spotlight':
        itemType = 'spotlight';
        break;
      case 'lb':
        itemType = 'liveblog';
        break;
      default:
        itemType = 'news';
    }
    return itemType;
  };

  return (
    <>
      {storiesData && Array.isArray(storiesData) && storiesData.length ? (
        <>
          <div className={s.wrapper}>
            <div className={s.contentwrapper}>
              <ul className={`${s.list}`}>
                {storiesData.map((item, index) => {
                  const itemClass = getItemType(item.tn, item.wu);
                  return (
                    <li>
                      {itemClass && itemClass === 'liveblog' ? (
                        <i className={`${s.liveBtn} ${s.red}`} />
                      ) : (
                        <i
                          className={`${
                            item.cs && item.cs === 'prime'
                              ? s.prime
                              : `${s[itemClass] || s.news}`
                          }`}
                        />
                      )}

                      <Link
                        to={item.wu}
                        target="_blank"
                        key={item.id}
                        onClick={event => {
                          onStoryClick(event, item, index);
                        }}
                      >
                        {item.hl}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          {sectionData &&
            sectionData?.moreLink && (
              <Morebtn
                moreText="More Trending Stories"
                absoluteMoreText="More Trending Stories"
                //   absoluteMoreText={`More ${sectionData.name}`}
                moreLink={sectionData?.moreLink}
                btnClass={s.moreBtn}
                linkData={{
                  gaAction: 'Click',
                  gaLabel: sectionData?.secName
                    ? `New_more_trending_stories_In-${sectionData?.secName}`
                    : '',
                }}
              />
            )}
        </>
      ) : null}
    </>
  );
};

ListingStoriesWidget.propTypes = {
  sectionData: PropTypes.shape({}),
  storiesData: PropTypes.arrayOf(PropTypes.shape({})),
  cardCount: PropTypes.number,
};

ListingStoriesWidget.defaultProps = {
  sectionData: {},
  storiesData: [],
  cardCount: 0,
};

export default ListingStoriesWidget;
